import Table from './Table'
import Attribute from './Attribute'

export class TableAttribute {
    ID: number;
    Table: Table;
    Attribute: Attribute;
}

export default TableAttribute;